export default "__VITE_ASSET__BABlR$1d__"